import React, { useState } from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";

// Your cities array here (truncated for demo; keep full data)
import citiesData from "./cities.json"; // 👉 move the big array into a JSON file

const UtahCities = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 15; // Number of rows per page

  // Generate Google Maps URL
  const generateMapLink = (cityName) => {
    return `https://www.google.com/maps?q=${encodeURIComponent(cityName)}, Utah`;
  };

  // 🔍 Filter cities based on search term
  const filteredCities = citiesData.filter(
    (city) =>
      city.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      city.county.toLowerCase().includes(searchTerm.toLowerCase()) ||
      city.type.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // 📄 Pagination logic
  const totalPages = Math.ceil(filteredCities.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedCities = filteredCities.slice(
    startIndex,
    startIndex + rowsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
      {/* Landing Section */}
      <LandingSection
        data={{ imageName: "cities.webp", title: "Cities", visible: true }}
      />

      <div className="utah-at-a-glance-section">
        <div className="utah-at-a-glance-intro">
          <div className="utah-at-a-glance-intro-sec1">
            <h2>
              Exploring Utah’s Dynamic Cities, From Urban Hubs to Scenic
              Gateways
            </h2>
          </div>
          <div className="utah-at-a-glance-intro-sec2">
            <p>
              Utah’s cities range from bustling metro centers like Salt Lake
              City to scenic towns such as Moab and St. George, each playing a
              vital role in the state’s economy, culture, and tourism.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="mx-auto py-12 w-full">
        {/* Intro Section */}
        <div className="text-center mb-8">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-900 mb-2">
            Utah Cities [{citiesData.length}]
          </h1>
          <p className="text-xl text-blue-700">
            Discover vibrant opportunities and connections across Utah’s
            communities
          </p>
        </div>

        {/* 🔍 Search */}
        <div className="flex justify-center mb-6">
          <input
            type="text"
            placeholder="Search by City, County, or Type..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1); // reset to first page on new search
            }}
            className="w-[40rem] p-3 border border-blue-300 rounded-3xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Table */}
        <div className="flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
            <div className="overflow-x-auto max-h-[800px]">
              <table className="min-w-full border border-gray-300">
                <thead className="sticky top-0 z-20">
                  <tr className="rounded-lg border border-pink-700 bg-red-200 transition-all duration-200">
                    {[
                      "Name",
                      "County",
                      "Type",
                      "Area",
                      "Elevation",
                      "Year",
                    ].map((col, i) => (
                      <th
                        key={i}
                        className="px-6 py-4 text-center text-[18px] font-bold text-blue-800 tracking-wider bg-red-200 border border-gray-300"
                      >
                        {col}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {paginatedCities.map((city, index) => (
                    <tr
                      key={index}
                      className="hover:bg-blue-50 transition-colors"
                    >
                      <td className="px-6 py-4 text-center border border-gray-300">
                        <a
                          href={generateMapLink(city.name)}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="font-bold text-base text-blue-900 hover:underline"
                        >
                          {city.name}
                        </a>
                      </td>
                      <td className="px-6 py-4 text-center font-bold text-blue-900 border border-gray-300">
                        {city.county}
                      </td>
                      <td className="px-6 py-4 text-center font-bold text-blue-900 border border-gray-300">
                        {city.type}
                      </td>
                      <td className="px-6 py-4 text-center font-bold text-blue-900 border border-gray-300">
                        {city.area}
                      </td>
                      <td className="px-6 py-4 text-center font-bold text-blue-900 border border-gray-300">
                        {city.elevation}
                      </td>
                      <td className="px-6 py-4 text-center font-bold text-blue-900 border border-gray-300">
                        {city.year}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="flex justify-center items-center gap-4 py-4 bg-blue-50">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-4 py-2 bg-blue-600 text-white rounded disabled:bg-gray-300"
              >
                Prev
              </button>
              <span className="text-blue-900 font-bold">
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-4 py-2 bg-blue-600 text-white rounded disabled:bg-gray-300"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default UtahCities;
